<template>
  <div>
    <div>
      <div class="template-setting-window">
        <div class="template-setting-window-header">
          <div class="template-setting-window-header-name">
            <strong>Рейсы по геозонам</strong>
            <br />
            <small>Настройка отчета</small>
          </div>
          <!-- Картинка крестика-->
          <img
            data-element="close"
            class="close"
            src="/images/close.png"
            @click="$emit('close', 'regularMovingByGeoTemplateSetting')"
          />
        </div>
        <div class="unselectable">
          <label :target="basketTarget">
            <input
              type="checkbox"
              v-model="isBasket"
            />
            Выгрузка по датчику поднятия кузова
            <span class="checkbox-target">({{ basketTarget }})</span> </label
          ><br />
          <label :target="weightTarget">
            <input
              type="checkbox"
              v-model="isWeight"
            />
            Рейсы по датчику погрузки
            <span class="checkbox-target">({{ weightTarget }})</span> </label
          ><br />
          <label :target="movingGroupTarget">
            <input
              type="checkbox"
              v-model="isMovingGroup"
            />
            Группировка рейсов
            <span class="checkbox-target">({{ movingGroupTarget }})</span>
          </label>
        </div>
        <div class="overflow-auto">
          <span
            class="my-underline"
            @click="geofencesWorkZoneShow = !geofencesWorkZoneShow"
          >
            Геозоны рабочей области:
          </span>
          <geofences-list-table
            v-show="geofencesWorkZoneShow"
            :geofences="geofencesWorkZone"
            :changeGeofences="changeGeofencesWorkZone"
            idName="work-zone"
          />
          <!-- {{ checkedGeofencesWorkZone }} -->
          <br />
          <span
            class="my-underline"
            @click="geofencesToTemplateShow = !geofencesToTemplateShow"
          >
            Геозоны для отчета:
          </span>
          <geofences-list-table
            v-show="geofencesToTemplateShow"
            :geofences="geofencesRegularZone"
            :changeGeofences="changeGeofencesToTemplate"
            idName="raid-zone"
          ></geofences-list-table>
          <!-- {{ checkedGeofencesToTemplate }} -->
          <div class="center-tag padding-top-5">
            <small>Окончание настройки отчета</small>
          </div>
        </div>
        <div class="center-tag">
          <span class="target-show"
            ><input
              class="btn btn-primary config-btn-primary btn-sm"
              type="submit"
              @click="calculateEvent"
              value="Выполнить отчет"
            /><span class="target-show-span"
              >Обсчет данных для получения отчета</span
            ></span
          >
        </div>
      </div>
    </div>
    <div
      @click="$emit('close', 'regularMovingByGeoTemplateSetting')"
      data-element="close"
      id="background-wrap"
      class="background-wrap"
      style="display: flex"
      wfd-invisible="true"
    ></div>
    <regular-moving-by-geo-template
      :geofences="geofences"
      :checkedGeofencesToTemplate="checkedGeofencesToTemplate"
      :checkedGeofencesWorkZone="checkedGeofencesWorkZone"
      :button="button"
      :buttonTarget="buttonTarget"
      :trigger="trigger"
      :isBasket="isBasket"
      :isWeight="isWeight"
      :isMovingGroup="isMovingGroup"
      :resetTrigger="resetTrigger"
      :form_desc="form_desc"
    ></regular-moving-by-geo-template>
  </div>
</template>

<script>
import GeofencesListTable from '../Shared/GeofencesListTable.vue';
import RegularMovingByGeoTemplate from './RegularMovingByGeoTemplate.vue';

export default {
  components: {
    GeofencesListTable,
    RegularMovingByGeoTemplate,
  },
  inject: [
    'authorizatedUserRights',
    'allGeofences',
    'geofencesUpdating',
    // "isGeofencesUpdating"
  ],
  props: {
    isShowing: {
      type: Boolean,
      require: true,
    },
    form_desc: {
      type: Object,
      require: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      // isShowing: false,
      showTemplateButton: {},
      geofences: [],
      checkedGeofencesToTemplate: [],
      geofencesWorkZoneShow: true,
      geofencesWorkZone: [],
      checkedGeofencesWorkZone: [],
      geofencesRegularZone: [],
      geofencesToTemplateShow: true,
      geofenceIds: {},
      button: {},
      buttonTarget: {},
      trigger: false,
      isBasket: false,
      isWeight: false,
      isMovingGroup: false,
    };
  },
  methods: {
    changeGeofencesToTemplate(checkedGeofences) {
      this.checkedGeofencesToTemplate = checkedGeofences;
    },
    changeGeofencesWorkZone(checkedGeofences) {
      this.checkedGeofencesWorkZone = checkedGeofences;
    },
    // showTemplateButtonEvent() {
    //   this.isShowing = true;
    // },
    // close(event) {
    //   if (event.target.dataset.element === "close") {
    //     this.isShowing = false;
    //   }
    // },
    geofencesListUpdate(flag) {
      if (!flag) return;
      const ids = {};
      this.allGeofences.forEach((geo) => {
        const { key } = geo;
        ids[key] = true;
        if (!this.geofenceIds[key]) {
          this.geofenceIds[key] = geo;
          this.geofences.unshift(geo);
        }
      });
      this.geofences = this.geofences.filter((geo) => {
        const { key } = geo;
        if (ids[key]) {
          return true;
        }
        delete this.geofenceIds[key];
      });
      this.geofencesWorkZone = this.geofences.filter(
        (geo) => parseInt(geo.type) === 8,
      );
      this.geofencesRegularZone = this.geofences.filter((geo) =>
        [1, 2, 3, 5].includes(parseInt(geo.type)),
      );
    },
    calculateEvent() {
      // this.isShowing = false;
      this.$emit('close', 'regularMovingByGeoTemplateSetting');
      this.trigger = true;
    },
    resetTrigger() {
      this.trigger = false;
    },
  },
  watch: {
    isShowing(flag) {
      this.geofencesListUpdate(flag);
    },
    isGeofencesUpdating(flag) {
      this.geofencesListUpdate(!flag);
    },
    isBasket(flag) {
      if (flag) {
        this.isWeight = false;
      }
    },
    isWeight(flag) {
      if (flag) {
        this.isBasket = false;
      }
    },
  },
  computed: {
    isGeofencesUpdating() {
      return this.geofencesUpdating.flag;
    },
    basketTarget() {
      if (this.isBasket) {
        return 'завершение рейса только по датчику поднятия кузова';
      }
      return 'датчик поднятия кузова не учитывается';
    },
    weightTarget() {
      if (this.isWeight) {
        return 'погрузки и разгрузки фиксируются по датчику нагрузки на ось';
      }
      return 'подсчет рейсов без учета датчика нагрузки на ось';
    },
    movingGroupTarget() {
      if (this.isMovingGroup) {
        return 'рейсы будут сгрупированы по геозонам погрузки и разгрузки';
      }
      return 'рейсы будут выведены по отдельности каждый в хронологическом порядке';
    },
  },
  mounted() {
    this.showTemplateButton = document.getElementById('get-template-button');
    this.button = document.getElementsByClassName('get-template-button-id')[0];
    this.buttonTarget = document.getElementsByClassName(
      'get-template-button-target-id',
    )[0];
  },
};
</script>

<style scoped>
.center-tag {
  text-align: center;
}
.template-setting-window {
  display: flex;
  padding: 4px 8px;
}
.my-underline {
  text-decoration: underline;
  cursor: pointer;
}
.checkbox-target {
  color: blue;
}
</style>
